import CartPage from '@/components/Cart/CartPage'
import CartAddress from '@/components/Cart/CartAddress'


let CartRouter = [
{
    path: '/cart',
    name: 'CartPage',
    component: CartPage
},{
    path: '/cart/address',
    name: 'CartAddress',
    component: CartAddress
}]

export default CartRouter



// WEBPACK FOOTER //
// ./src/components/Cart/router.js